<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Dashboard" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div class="card-with-tab mb-3">
            <div class="">
              <ul class="nav nav-pills">
                <li
                  v-for="tab in upperTabs"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="
                      `nav-link ${
                        tab.label == 'TURNOVER INTERVAL' ? 'active' : ''
                      }`
                    "
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-11">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-1 pt-1 pl-0">
                <button class="btn btn-primary mt-4 btn-block" @click="apply">
                  Apply
                </button>
              </div>
            </div>
          </div>
          <div v-if="loaded">
            <div class="py-4" v-if="hBarData || pieData || barData">
              <div class="row mb-4">
                <div class="col-md-9">
                  <h4 class="py-2">
                    Menampilkan Turnover Interval
                    {{
                      formSet.dari
                        ? formSet.sampai
                          ? `periode ${formSet.dari} sampai ${formSet.sampai}:`
                          : `sejak ${formSet.dari} sampai saat ini`
                        : formSet.sampai
                        ? `sampai periode ${formSet.sampai}`
                        : ``
                    }}
                    <!-- periode {{ formSet.dari }} sampai {{ formSet.sampai }} -->
                  </h4>
                </div>
                <div class="col-md-3">
                  <a
                    href=""
                    @click="print"
                    class="btn btn-outline-secondary btn-with-icon-left"
                  >
                    <i class="material-symbols-outlined">cloud_download</i>
                    Download Laporan
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card" style="height:100%">
                    <div class="row">
                      <div class="col-md-12 py-4 px-5">
                        <div v-if="hBarData" style="position: relative">
                          <h3 class="text-center mt-3 mb-4">
                            Turnover Interval
                          </h3>
                          <horizontal-bar-chart
                            :chart-data="hBarData"
                            :options="{
                              maintainAspectRatio: false,
                              scales: {
                                xAxes: [
                                  {
                                    ticks: {
                                      beginAtZero: true,
                                      min: 0,
                                    },
                                  },
                                ],
                              },
                            }"
                          ></horizontal-bar-chart>
                        </div>
                        <div v-else>
                          <EmptyState
                            :data="{
                              img: '/img/chart.svg',
                              title: 'Tidak ada data di sini',
                              content:
                                'Tidak ada grafik data penyakit menular di sini',
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-4" v-else>
              <EmptyState
                :data="{
                  img: '/img/chart.svg',
                  title: 'Tampilkan grafik di sini',
                  content: 'Terapkan filter di atas untuk menampilkan grafik',
                  size: 'medium mb-0',
                }"
              />
            </div>
          </div>
          <Loading v-else />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DoughnutChart from "@/components/DoughnutChart.js";
// import BarChart from "@/components/BarChart.js";
import HorizontalBarChart from "@/components/HorizontalBarChart.js";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import { ageInterval, getInputDate } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  data,
  tabs,
  filtersRujukan,
  sort,
  upperTabs,
  singleSelectRujukan,
} from "@/data/Dashboard.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "DashboardRujukan",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    // DoughnutChart,
    // BarChart,
    HorizontalBarChart,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      chartStyles: { height: "25vw", position: "relative" },
      pieData: null,
      barData: null,
      hBarData: null,
      loaded: true,
      data: data,
      filters: filtersRujukan,
      sort: sort,
      tabs: tabs,
      upperTabs: upperTabs,
      total: 0,
      formSet: {
        dari: "",
        sampai: "",
      },
      single_select: null,
    };
  },
  methods: {
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
      //console.log(this.formSet);
      // await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
      // this.apply();
    },
    print: function() {
      window.print();
    },
    fillData: async function() {
      this.pieData = {
        labels: ["Laki-laki", "Perempuan"],
        datasets: [
          {
            label: "",
            backgroundColor: ["#097CEB", "#e52e6b"],
            data: [this.getRandomInt(), this.getRandomInt()],
          },
        ],
      };

      this.barData = {
        labels: [
          "<1 Tahun",
          "1-4 Tahun",
          "5 -14 Tahun",
          "15-44 Tahun",
          "45 - 64 Tahun",
          "> 65 Tahun",
        ],
        datasets: [
          {
            label: "Total",
            backgroundColor: "#c42a9d",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
          {
            label: "Laki-laki",
            backgroundColor: "#097CEB",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
          {
            label: "Perempuan",
            backgroundColor: "#e52e6b",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
        ],
      };
    },
    apply: async function() {
      //console.log(this.formSet);
      this.loaded = false;
      this.errors = [];
      let params = ``;
      let self = this;
      Object.keys(this.formSet).forEach(function(key) {
        if (self.formSet[key]) {
          params += `${key}=${self.formSet[key]}&`;
        } else {
          if (key == "dari") {
            params += `${key}=2012-01-01&`;
          } else if (key == "sampai") {
            params += `${key}=${getInputDate()}&`;
          }
        }
      });
      let colors = ["#097ceb", "#e52e6b", "#16a085"];
      try {
        let result = await this.$store.state.HTTP.get(
          "dashboard/turn_over_interval?" + params
        );
        //console.log(result);
        if (result.status == "200" && result.data) {
          this.hBarData = {
            labels: ["TOI"],
            datasets: [
              {
                label: "Turnover Interval (dalam hari)",
                backgroundColor: "#e52e6b",
                data: [result.data.toi],
              },
            ],
          };

          // this.hBarData = result.data.horizontal_bar_chart;

          // let pie_chart = {
          //   labels: result.data.horizontal_bar_chart.labels,
          //   datasets: result.data.horizontal_bar_chart.datasets[0].persentase,
          // };
          // //console.log(result.data.pie_chart);

          // if (pie_chart) {
          //   let pie = pie_chart;
          //   this.pieData = {
          //     labels: pie.labels,
          //     datasets: [
          //       {
          //         label: "",
          //         backgroundColor: ["#097CEB", "#e52e6b"],
          //         data: pie.datasets,
          //       },
          //     ],
          //   };
          // } else {
          //   this.pieData = null;
          // }
          if (result.data.bar_chart) {
            let bar = result.data.bar_chart;
            this.barData = {
              labels: bar.datasets.map((item) => item.label),
              datasets: [
                {
                  label: "Total",
                  backgroundColor: "#c42a9d",
                  data: bar.datasets.map((item) => item.data[0]),
                },
                {
                  label: "Laki-laki",
                  backgroundColor: "#097CEB",
                  data: bar.datasets.map((item) => item.data[1]),
                },
                {
                  label: "Perempuan",
                  backgroundColor: "#e52e6b",
                  data: bar.datasets.map((item) => item.data[2]),
                },
              ],
            };
          } else {
            this.barData = null;
          }

          this.loaded = true;
        } else {
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    // await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    // this.apply();
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
